export default __webpack_public_path__ + "static/media/auto-transmission-clutch.21892c50.svg";